import React, {useEffect} from "react";
import {List, CellMeasurerCache, CellMeasurer, AutoSizer} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import RowItem from "../selectionRowList/rowItem";
import RowItemRelatedProducts from "../selectionRowList/rowItemRelatedProducts";
import {IsMountedElement, useIsMounted} from "../../../misc/helperHooks";
import {setRowItems} from "../../../actions/selectionFunctions";
import {WIZARD_GROUP_TYPES, wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import SelectionGridWizardGroupItem from "../selectionGridList/selectionGridWizardGroupItem";

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 155
})

const SelectionMainVirtualizedList = (props) => {

  const {currentFeatures, checkIfFeatureSelected, handleFeatureClick, rowItems, currentParent, setRowItems, onScroll,
    isWizard, currentGroups} = props;
  const isMounted = useIsMounted();

  // const [, updateState] = useState();
  // const forceUpdateList = useCallback(() => updateState({}), []);

  useEffect(() => {
    return () => {
      setRowItems([]);
      cache.clearAll();
    }
  }, [setRowItems]);

  const noRowsRenderer = () => <div className={"ass-list"}>No features found</div>;

  const rowRenderer = ({index, parent, key, style}) => {
    const currentFeature = currentFeatures[index] ? currentFeatures[index].part : null;
    const navItem = currentFeatures[index];
    const selected = checkIfFeatureSelected(currentFeature, currentParent);

    let relatedFeatures = [];
    const featureRelatedFeatures = currentFeature ? currentFeature.getFeatureRelatedFeatures() : null;
    if (featureRelatedFeatures && Array.isArray(featureRelatedFeatures) && featureRelatedFeatures.length) {
      const thisFeatureAdded = rowItems.find(rItem => rItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id);
      if (thisFeatureAdded && thisFeatureAdded.showRowRelatedItems) {
        relatedFeatures = featureRelatedFeatures
      }
    }

    return (
      <CellMeasurer key={key}
                    cache={cache}
                    parent={parent}
                    columnIndex={0}
                    rowIndex={index}>
        {({measure}) => {
          if (isWizard && (currentGroups.length > 1 || (currentGroups[0] && currentGroups[0].nodeType === WIZARD_GROUP_TYPES.custom))) {
            // return null // we don't use rows, removed for now!
            if (!currentFeatures[index].id) {
              return null
            }
            return (
              <div className="m-feature" style={style}>
                <SelectionGridWizardGroupItem isRowItem={true}
                                              handleFeatureClick={handleFeatureClick}
                                              wizardGroup={currentFeatures[index]}  />
              </div>
            )
          }

          return (
            <IsMountedElement className="m-feature" style={style}>
              {(isMountedComponent) => {
                const updateVirtualizedCache = () => {
                  if (isMounted() && isMountedComponent()) {
                    // cache.clear(index);
                    measure();
                  }
                }

                return (
                  <>
                    <RowItem selected={selected}
                             isWizard={isWizard}
                             wizardGroup={currentGroups ? currentGroups[0] : null}
                             currentFeature={currentFeature}
                             navItem={navItem}
                             handleFeatureClick={(navFeature, event) => {
                               updateVirtualizedCache();
                               handleFeatureClick(navFeature, event)
                             }}/>
                    {relatedFeatures.length
                      ? <RowItemRelatedProducts relatedFeatures={relatedFeatures}
                                                currentFeature={currentFeature}
                                                updateVirtualizedCache={updateVirtualizedCache}/>
                      : null}
                  </>
                )
              }}
            </IsMountedElement>
          )
        }}
      </CellMeasurer>
    );
  }

  const listSettings = {
    overscanRowCount: 6,
    rowCount: currentFeatures.length,
  }

  return (
    <AutoSizer>
      {({width, height}) => (
        <List
          // ref="List"
          className={"selection-main-rows"}
          width={width}
          height={height}
          overscanRowCount={listSettings.overscanRowCount}
          rowCount={listSettings.rowCount}
          deferredMeasurementCache={cache}
          rowHeight={cache.rowHeight}
          rowRenderer={rowRenderer}
          noRowsRenderer={noRowsRenderer}
          onScroll={onScroll}
        />
      )}
    </AutoSizer>
  )
}

SelectionMainVirtualizedList.propTypes = {
  currentFeatures: PropTypes.array,
  checkIfFeatureSelected: PropTypes.func.isRequired,
  handleFeatureClick: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  currentParent: PropTypes.object,
  isWizard: PropTypes.bool,
  currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)),
}

const mapStateToProps = (store) => {
  return {
    rowItems: store.selectionState.rowItems,
  };
};

const mapDispatchToProps = {
  setRowItems
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainVirtualizedList)
